/* eslint-disable */
var form = function () {

    'use strict';

    var self = {};

    /* private properties */
    const $searchNode = jQuery('.search-node');

    /* public methods */

    self.init = function () {
        jQuery('.content-form input').on('keyup', deleteButton);
        jQuery('.search-button a').on('click', startSearch);
        jQuery('.search-button input').on('click', startSearch);
        $searchNode.find('.close').on('click', endSearch);
        jQuery('.partner-search-item .all').on('click', showList);
        jQuery('.partner-search-item .close-list').on('click', hidelist);
    };


    self.redraw = function () {
        jQuery('.partner-search-item .list').removeAttr('style');
        jQuery('.partner-search-item .search-button a').removeAttr('style');
        jQuery('.partner-search-item .search-button .close-list').removeAttr('style');
        $searchNode.removeAttr('style');
        jQuery('.partner-search-item').removeClass('open');
    };

    /* private methods */

    function deleteButton() {
        var input = jQuery(jQuery(this));
        var item = jQuery(this).parent();
        var deleteBtn = null;

        item.removeClass('error').find('span').remove();

        if (this.value) {
            item.toggleClass('is-full');

            if (item.find('.delete').length == 0) {
                item.append('<div class="delete"></div>');

                item.find('.delete').on('click', function() {
                    input.val('');
                    item.find('.delete').remove();
                });
            }
        }
        else {
            item.find('.delete').remove();
        }
    }

    function startSearch(e) {
        e.preventDefault();
        $searchNode.fadeIn(350);
        jQuery('.search-item input', $searchNode).focus();
    }

    function endSearch() {
        $searchNode.fadeOut(350);
    }

    function showList(e) {
        e.preventDefault();
        jQuery('.partner-search-item .list').slideDown(350);
        jQuery('.partner-search-item .search-button a').fadeOut(350);
        jQuery('.partner-search-item .search-button .close-list').fadeIn(350);
        jQuery('.partner-search-item').addClass('open');
    }

    function hidelist() {
        jQuery('.partner-search-item .list').slideUp(350);
        jQuery('.partner-search-item .search-button a').fadeIn(350);
        jQuery('.partner-search-item .search-button .close-list').fadeOut(350);
        jQuery('.partner-search-item').removeClass('open');
    }

    return self;
};

window.form = new form();
